import React from "react";

/**
 * Hero — full-width banner with bismillah + Al-Yasin title.
 */
function Hero() {
  return (
    <header className="hero-section text-white text-center">
      <div className="hero-bg"></div>
      <div className="hero-content container">
        <h1 className="display-5 arabic-text mb-3">
          بِسْمِ ٱللَّٰهِ ٱلرَّحْمَـٰنِ ٱلرَّحِيمِ
        </h1>
        <h1 className="fw-bold display-4 arabic-text-gold">
          Al-Yasin آل ياسين
        </h1>
        <p className="lead">
          Styrker elever i tajweed og Koran-resitasjon
        </p>
      </div>
    </header>
  );
}

export default Hero;
